export const credAndUrl = {
    BASE_URL: 'https://backend.thebrandcabin.com/api/v1/',
    BUCKET_NAME: process.env.REACT_APP_BUCKET_NAME,
    DIR_NAME: process.env.REACT_APP_BUCKET_DIR,
    REGION: process.env.REACT_APP_BUCKET_REGION,
    ACCESS_KEY_ID: process.env.REACT_APP_BUCKET_ACCESSKEYID,
    SECRET_ACCESS_KEY: process.env.REACT_APP_BUCKET_SECRETACCESSKEY,
}

//https://backend.thebrandcabin.com/api/v1/',
// 'https://skyrixe.com/api/v1/',
// http://localhost:4008/api/v1/